export default __webpack_public_path__ + "static/media/xmas-popup.2bbfc557.webp";